// Integration Links am Lead und am Kontakt (Runde 8, Agent 8B; C-14, C-15). Die linke Spalte (`LinkeSpalte.tsx`, Agent 7B) bindet die
// Komponente unter "Über" ein; für die Kontakte bindet 7B sie in `Kontakte.tsx` mit `objekt="contact"` ein. Zeigt kleine Links
// (Name, Pfeil) aus `organisationApi.fuer(objekt, objektId)` (`GET /api/integration-links/fuer/{objekt}/{id}`), die in einem neuen
// Tab öffnen. Der Server setzt die Daten des Objekts in die Adresse ein; ohne Links (oder ohne die nötigen Daten) zeigt sie nichts.
// Die Links ändern sich selten: einmal laden, bei `meta.updated` (Einstellungen geändert) und beim Wechsel des Objekts neu.
import { useCallback, useEffect, useState } from "react";
import { organisationApi, type AufgeloesterLink, type LinkObjekt } from "../../api/organisation";
import { useEchtzeit } from "../../api/echtzeit";
import { Icon } from "../Icon";
import "../../stammdaten/links.css";

export interface IntegrationLinksProps {
  objekt: LinkObjekt;
  objektId: string;
}

export function IntegrationLinks({ objekt, objektId }: IntegrationLinksProps) {
  const [links, setLinks] = useState<AufgeloesterLink[]>([]);

  const laden = useCallback(() => {
    let aktuell = true;
    organisationApi
      .fuer(objekt, objektId)
      .then((r) => {
        if (aktuell) setLinks(r.data);
      })
      .catch(() => {
        if (aktuell) setLinks([]); // Links sind eine Zugabe: ein Fehler stört die Lead-Seite nicht
      });
    return () => {
      aktuell = false;
    };
  }, [objekt, objektId]);

  useEffect(() => laden(), [laden]);
  useEchtzeit(["meta.updated", "lead.updated"], (e) => {
    if (e.type === "meta.updated" || e.lead_id === objektId) laden();
  });

  if (!links.length) return null;
  return (
    <ul className="il-links" aria-label="Links">
      {links.map((l) => (
        <li key={l.id}>
          <a className="il-links__link" href={l.url} target="_blank" rel="noopener noreferrer" title={l.url}>
            {l.name}
            <Icon name="extern" groesse={11} />
          </a>
        </li>
      ))}
    </ul>
  );
}
